"use strict";

/**
 * @classdesc
 * Featureobjekt einer Transaktions-Funktion des FeatureServices.
 *
 * @class
 * @abstract
 * @extends gc.gis.GCObservable
 * @memberof gc.gis.service
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.service.feature.AbstractTransactionFeature = function()
{
	gc.gis.GCObservable.call(this);

	/**
	 * ID des Features.
	 * @type {string|int}
	 * @private
	 */
	this._id = undefined;

	/**
	 * Liste der Attribute.
	 * @type {Object<string,*>}
	 * @private
	 */
	this._attributes = {};
};
gc.gis.service.feature.AbstractTransactionFeature.prototype = Object.create(gc.gis.GCObservable.prototype);

/**
 * Liefert die ID des Features.
 *
 * @return {string|int}
 */
gc.gis.service.feature.AbstractTransactionFeature.prototype.getID = function ()
{
	return this._id;
};

/**
 * Setzt die ID des Features.
 *
 * @param {string|int} id
 * @return {gc.gis.service.feature.AbstractTransactionFeature}
 */
gc.gis.service.feature.AbstractTransactionFeature.prototype.setID = function (id)
{
	this._id = id;

	return this;
};

/**
 * Liefert ein Attributwert.
 *
 * @return {*}
 */
gc.gis.service.feature.AbstractTransactionFeature.prototype.getAttribute = function (name)
{
	var attr;
	if (name)
	{
		name = name.toLowerCase();
		if (this._attributes.hasOwnProperty(name))
		{
			attr = this._attributes[name];
		}
	}

	return attr;
};

/**
 * Liefert de Attribute.
 *
 * @return {Object.<string, *>}
 */
gc.gis.service.feature.AbstractTransactionFeature.prototype.getAttributes = function ()
{
	return this._attributes;
};

/**
 * Setzt einen Attributwert.
 *
 * @param {string} name
 * @param {*} value
 * @return {gc.gis.service.feature.AbstractTransactionFeature}
 */
gc.gis.service.feature.AbstractTransactionFeature.prototype.setAttribute = function (name, value)
{
	this._attributes[name.toLowerCase()] = value;
	return this;
};

/**
 * Setzt einen Attributwert.
 *
 * @param {Object.<string, *>} attributes
 * @return {gc.gis.service.feature.AbstractTransactionFeature}
 */
gc.gis.service.feature.AbstractTransactionFeature.prototype.setAttributes = function (attributes)
{
	var name;
	for (name in attributes)
	{
		if (attributes.hasOwnProperty(name))
		{
			this.setAttribute(name, attributes[name]);
		}
	}
	return this;
};

/**
 * Setzt einen Attributwert zurück.
 *
 * @param {string} name
 * @return {gc.gis.service.feature.AbstractTransactionFeature}
 */
gc.gis.service.feature.AbstractTransactionFeature.prototype.unsetAttribute = function (name)
{
	name = name.toLowerCase();
	if (name in this._attributes)
	{
		delete this._attributes[name];
	}
	return this;
};